// const root = '#tippy-reference';
// const root = '.popover-body--panels';
const root = '#popover-body-container';

const state = {
  popup_offset_class: 'tippy-reference-content',
  tabs_count: null,
  panel_count: null
};

/**
 * Range generator - 0.1.2.3.etc.
 *
 * @param start
 * @param end
 * @param step
 * @returns {Generator<number, number, *>}
 */
function* makeRangeIterator(start = 0, end = 100, step = 1) {
  let iterationCount = 0;
  for (let i = start; i < end; i += step) {
    iterationCount++;
    yield i;
  }
  return iterationCount;
}

class Accordion {

  constructor(rootElement = root) {
    this.root = document.querySelector(rootElement);

    this.panels = this.root.querySelectorAll('.popover-body--panels-panel');
    this.setNumTabs();

    this.webformPanels = this.getWebformPanels(this.panels);
    this.getFormPanelsTabs(this.webformPanels);
  }

  setNumTabs() {
    const popupOffset = document.querySelector(`.${state.popup_offset_class}`);
    const tabsHeader = popupOffset.querySelector('.js-tabs__tabs-container');
    state.tabs_count = tabsHeader.childElementCount;
  }

  countWebformPanels(wfPanels) {
    state.panel_count = wfPanels.length;
  }

  getFormPanelsTabs(panels) {
    const { tabs_count } = state;

    const tabIterator = makeRangeIterator(0, tabs_count);

    for (let tab_number of tabIterator) {
      let tabPanels = panels.filter(pane => parseInt(pane.getAttribute('data-tab-number')) === tab_number);
      if (tabPanels.length > 1) {
        this.setupCollapsible(tabPanels);
      }
    }
  }

  getWebformPanels(panels) {
    return Array.from(panels).filter(panel => {
      return panel.firstElementChild.classList.contains('webform_panel');
    });
  }

  /**
   * Event listener
   * @param panel
   */
  panelClick(panel) {
    const { header, webformPanel } = panel;
    let panelState = webformPanel.getAttribute('aria-expanded');

    if (panelState && panelState === 'true') {
      header.setAttribute('aria-selected', 'false');
      webformPanel.setAttribute('aria-expanded', 'false');
    } else {
      header.setAttribute('aria-selected', 'true');
      webformPanel.setAttribute('aria-expanded', 'true');
    }
  }

  /**
   * Setup accordion panels
   *
   * @param panels
   */
  setupCollapsible(panels) {
    panels.forEach(panel => {
      let eachPanel = {
        accordionPanel: panel,
        webformPanel: panel.firstElementChild,
        header: panel.firstElementChild.querySelector('.panel__teaser'),
        body: panel.firstElementChild.querySelector('.webform')
      };

      panel.classList.add('is-collapsible');
      eachPanel.webformPanel.setAttribute('aria-expanded', 'false');

      eachPanel.header.addEventListener('click', () => {
        this.panelClick(eachPanel);
      });

      // this.panelClick(eachPanel);
    });
  }
}

new Accordion();
